import { declint } from "../Engine/utils";

export function getTotalCountText(
    itemsLength: number,
    totalCount: number,
    isSearchText: boolean,
    helpPartText?: string
): string {
    if (isSearchText) {
        return `Показано ${itemsLength} из ${declint(totalCount, [
            "%s найденного значения",
            "%s найденных значений",
            "%s найденных значений",
        ])}. Уточните запрос, чтобы увидеть остальные.`;
    }

    return `Показано ${itemsLength} из ${declint(totalCount, ["%s значения", "%s значений", "%s значений"])}. ${
        helpPartText || "Начните вводить код или название"
    }, чтобы увидеть остальные.`;
}
